var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M12.833 12H10a3 3 0 010-6h3.786A2.714 2.714 0 0116.5 8.714V9m-5.333 3H14a3 3 0 110 6h-3.786A2.714 2.714 0 017.5 15.286V15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 3.5h2V5h-2zM11 19h2v1.5h-2z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTEyLjgzMyAxMkgxMGEzIDMgMCAwIDEgMC02aDMuNzg2QTIuNzE0IDIuNzE0IDAgMCAxIDE2LjUgOC43MTRWOW0tNS4zMzMgM0gxNGEzIDMgMCAxIDEgMCA2aC0zLjc4NkEyLjcxNCAyLjcxNCAwIDAgMSA3LjUgMTUuMjg2VjE1Ii8+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMTEgMy41aDJWNWgtMnpNMTEgMTloMnYxLjVoLTJ6Ii8+PC9zdmc+";
export { SvgDollar as ReactComponent };